import { defineComponent as _defineComponent } from 'vue'
import FormInput from "@/components/lib/input/FormInput.vue";
import SelectStatusFilter from "@/components/select/status/SelectStatusFilter.vue";
import ActionButton from "@/components/lib/button/ActionButton.vue";
import { computed, ref } from "vue";
import {
  getDefaultFilter,
  useCompanyUsersStore,
} from "@/pinia/subcompanies/companyUsers";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyUsersListGridFilter',
  setup(__props) {

const companyUsersStore = useCompanyUsersStore();

const searchInputValue = ref<string>("");
const statusSelectValue = ref<string>("ALL");

const showSetDefaultFiltersValueBtn = computed(() => {
  return searchInputValue.value.length > 0 || statusSelectValue.value != "ALL";
});

function handleSearchInputChangeEvent(text: string) {
  searchInputValue.value = text;
}

function handleStatusSelectChangeEvent(selected: string) {
  statusSelectValue.value = selected;
}

function okBtnListener() {
  companyUsersStore.filter = {
    search: searchInputValue.value,
    status: statusSelectValue.value === "ALL" ? null : statusSelectValue.value,
  };
}

function cancelBtnListener() {
  const defaultFilter = getDefaultFilter();
  searchInputValue.value = defaultFilter.search;
  statusSelectValue.value = defaultFilter.status ?? "ALL";
  companyUsersStore.filter = defaultFilter;
}

function getOutLineStatus() {
  const filter = useCompanyUsersStore().filter;
  return !filter.search.length && !filter.status;
}

return { __sfc: true,companyUsersStore, searchInputValue, statusSelectValue, showSetDefaultFiltersValueBtn, handleSearchInputChangeEvent, handleStatusSelectChangeEvent, okBtnListener, cancelBtnListener, getOutLineStatus, FormInput, SelectStatusFilter, ActionButton }
}

})